const config={
    'server':{
        'link': process.env.REACT_APP_SERVER
    },
    'client':{
        'link': process.env.REACT_APP_CLIENT
    }
}


export default config;